module.exports = __webpack_public_path__ + "img/s06-bg1.cbf167bd.jpg";